import React, { useRef } from 'react';
import { iphoneAppDownload, androidAppDownload, iphoneRedeemCode } from '../link-actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faArrowCircleUp} from '@fortawesome/free-solid-svg-icons';
import LogoText from '../components/logoText';
import {Pricing} from "../components/Pricing";

export const GolfVideo = () => {
    const introVid = useRef(null);
    const introButton = useRef(null);
    const special = useRef(null);
    let showSpecial = false;
    let sportKey = "golf";
    let promo = {
        name:'FedEx Cup Special',
        expiry: '24 Aug 2025',
        code: 'FEDEX25'
    }
/*
<div className="col-xl-7 col-lg-7 col-12 align-self-center" style={{marginBottom:'20px'}}>
                            <div className="atf-single-about-img text-center my-auto">
                                <h2 style={{ fontSize: '26px', lineHeight: "1.6", marginBottom: '20px' }}>Like recording your swing?</h2>
                                <h2 style={{ display:'inline-block', fontSize: '26px', marginTop: "10px", width: '50px', height: '50px', padding: '2px', borderRadius:'40px', backgroundColor: 'yellowgreen', color:"white"}}>5</h2>
                                <h2 style={{ fontSize: '26px', lineHeight: "1.6", color: "yellowgreen" }}>Reasons you'll love <LogoText light={false} /></h2>
                                <button onClick={() => { window.gtag('event', `video_play_${sportKey}_top`); introVid.current.play(); }} style={{padding: "10px 20px", fontSize: '14px', color: "white", background: "yellowgreen", border: '0px', borderRadius: '20px', marginTop:'20px'}}>Watch demo</button>


                            </div>
                        </div>

                        <div className="col-xl-5 col-lg-5 col-12 align-self-center text-center">
                            <video ref={introVid} controls width={"100%"} poster={"./watch_at_feet.png"} style={{marginTop: '20px'}}>
                                <source src="/assets/video/practiceLoopIntro.mp4" type="video/mp4" />
                            </video>

                        </div>

 */
    return (<div>
        <div className="non-landing-banner"></div>
            <section className="atf-about-area atf-shape" style={{background: 'var(--thm-black)'}}>
                <div className="container">
                    <div className="row clearfix align-self-center" ref={introButton}  >
                        <div className={"col-12 text-center align-self-center"} style={{padding: "20px 0px"}}>
                            <h2 style={{ fontSize: '42px', marginTop: '30px', marginBottom: '50px', color:"white" }}>Hassle free<br />swing recording</h2>
                            <div style={{ fontSize: '22px', lineHeight: "1.3", color: "yellowgreen" }}>Love recording your swing?<br/>Hate messing with your phone?</div>
                            <div style={{ fontSize: '18px', lineHeight: "1.3", color: "white", marginTop:'40px' }}>Try <LogoText light={true}/></div>
                            <div>
                                <a href="#" onClick={() => iphoneAppDownload(`${sportKey}_video_top`)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                <a href="#" onClick={() => androidAppDownload(`${sportKey}_video_top`)} ><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={{ height: '65px' }} /></a>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section  className="atf-section-padding">
                <div className="container">
                    <div className="row justify-content-center clearfix">
                        <div className="col-lg-8 col-12 text-center align-self-center">
                            <div>
                                <h2 style={{ fontSize: '30px', marginTop: "5px", marginBottom: "10px", lineHeight: "1.5", color:"var(--thm-black)"}}>Real-time replays, after every shot.<br /><span style={{color: "yellowgreen"}}>All hands free.</span></h2>
                                <p style={{ fontSize: "18px", margin: "15px 0 20px 0" }}>The purpose of video feedback is to improve. The faster the feedback, the faster the improvement.</p>

                            </div>
                        </div>
                        <div className="col-lg-4 col-12 text-center">
                            <img src="./assets/img/golf/sequence.gif" alt="Swing detection" style={{width: "70%", marginTop: '30px'}} />
                            <p style={{ fontSize: "18px", margin: "15px 0 20px 0" }}>PracticeLoop shows an instant replay, automatically, after every swing</p>
                        </div>

                    </div>
                </div>
            </section>

          <div className={"row"}>
              <div className="col-12 text-center align-self-center">
                  <div style={{marginBottom: '30px'}}>
                      <a href="#" onClick={() => iphoneAppDownload(`${sportKey}_video_mid`)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                      <a href="#" onClick={() => androidAppDownload(`${sportKey}_video_mid`)} ><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={{ height: '65px' }} /></a>
                      <p>Try it yourself</p>
                  </div>
              </div>
          </div>
          <section className="atf-section-padding" style={{background: 'yellowgreen'}}>
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 d-block d-lg-none  text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"white"}}>Stream replay to a tablet or laptop</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0", color:'white'  }}>Connect a tablet or laptop and see the replay on a bigger screen, at your feet.</p>
                          </div>
                      </div>
                      <div className="col-lg-5 col-12 text-center">
                          <img src="./assets/img/driving_range_pov.png" alt="Watch replay at your feet" style={{marginTop: '30px'}} />
                      </div>
                      <div className="col-lg-7 col-12  d-none d-lg-block  text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"white"}}>Stream replay to a tablet or laptop</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0", color:'white' }}>Connect a tablet or laptop and see the replay on a bigger screen, at your feet.</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

          <section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"var(--thm-black)"}}>Your swings are saved individually.<br/><span style={{color: 'yellowgreen'}}>For easy playback.<span style={{fontSize:'20px', verticalAlign: 'super'}}>*</span></span></h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0",  }}>All shots are automatically saved, individually, so you can re-watch them with a single tap.</p>
                          </div>
                      </div>
                      <div className="col-lg-5 col-12 text-center">
                          <img src="/assets/img/golf/sessionlib.png" alt="Save individual swings" style={{width: "85%", marginTop: '30px'}}/>
                      </div>
                  </div>
              </div>
          </section>

          <section className="atf-section-padding" style={{background: 'var(--thm-black)'}}>
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 d-block d-lg-none  text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"white"}}>Export your entire practice to video<span style={{fontSize:'20px', verticalAlign: 'super'}}>*</span></h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0", color:'white'  }}>Create a single video with all your swings, back-to-back. Nothing in-between.</p>
                              <p style={{ fontSize: "12px", margin: "15px 0 0px 0", color:'white' }}>*IPhone only.  Coming soon to Android.</p>
                          </div>
                      </div>
                      <div className="col-lg-5 col-12 text-center">
                          <video controls width={"100%"}  style={{width: "90%", marginTop: '30px'}}>
                              <source src="/assets/img/golf/export_sample.mp4" type="video/mp4" />
                          </video>
                      </div>
                      <div className="col-lg-7 col-12  d-none d-lg-block  text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"white"}}>Export your entire practice to video<span style={{fontSize:'20px', verticalAlign: 'super'}}>*</span></h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0", color:'white' }}>Create a single video with all your swings, back-to-back. Nothing in-between.</p>
                              <p style={{ fontSize: "12px", margin: "15px 0 0px 0", color:'white' }}>*IPhone only.  Coming soon to Android.</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

          <section className="atf-section-padding" style={{background: 'yellowgreen'}}>
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"white"}}>Fast replays mean fast improvement</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0", color:"white"  }}>Watch this 60 second demo or try it yourself</p>
                              <div style={{marginTop: '30px'}}>
                                  <a href="#" onClick={() => iphoneAppDownload(`${sportKey}_video_mid`)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                  <a href="#" onClick={() => androidAppDownload(`${sportKey}_video_mid`)} ><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={{ height: '65px' }} /></a>
                              </div>
                          </div>
                      </div>
                      <div className="col-lg-5 col-12 text-center">
                          <video ref={introVid} controls width={"100%"} poster={"./watch_at_feet.png"} style={{marginTop: '20px'}}>
                              <source src="/assets/video/website-demo-video.mp4" type="video/mp4" />
                          </video>
                      </div>
                  </div>
              </div>
          </section>
          <section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 d-block d-lg-none  text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"var(--thm-black)"}}>Go straight to any swing. No scrolling.</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0"  }}>Go to your previous or next swing with a single tap</p>
                          </div>
                      </div>
                      <div className="col-lg-5 col-12 text-center">
                          <img src="/assets/img/golf/sessionnext.gif" alt="Previous Next Swings" style={{width: "76%", marginTop: '30px'}}/>
                      </div>
                      <div className="col-lg-7 col-12  d-none d-lg-block  text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"var(--thm-black)"}}>Go straight to any swing. No scrolling.</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0" }}>Go to your previous and next swings with scrolling through video</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
          <section className="atf-section-padding" style={{ paddingTop: "40px", paddingBottom: "0px" }}>
              <div className="container">
                  <div className="row justify-content-center" style={{backgroundColor: "yellowgreen"}}>
                      <div className="col-12 align-self-center text-center" style={{backgroundImage: 'url(assets/img/golf_collage.png)', backgroundSize: 'cover', backgroundPosition: 'center center'}}>
                          <div style={{ margin: '20px 10px 20px 10px', padding: '10px', background:"white"}}>
                              <h2 style={{ display: "inline-block", fontSize: '34px', lineHeight:"1.5", marginBottom: "10px", color:"var(--thm-black)",padding: "5px"}}>500+ installs</h2><br />
                              <h2 style={{ display: "inline-block", fontSize: '18px', marginBottom: "10px", lineHeight: "1.5", padding: "3px"}}>"If you like recording your swing, you'll love PracticeLoop"</h2>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
          <section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"var(--thm-black)"}}>Don't fiddle with your phone to watch recordings.</h2>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"yellowgreen"}}>Watch every replay, after every shot.</h2>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"#999999"}}>Hands free.</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0"  }}>Replays after every swing, without touching your phone.</p>

                          </div>
                      </div>
                      <div className="col-lg-5 col-12 text-center">
                          <img src="./assets/img/golf/framebyframe.gif" alt="Watch frame-by-frame" style={{width: "70%", marginTop: '30px'}} />
                      </div>
                  </div>
              </div>
          </section>

        <Pricing/>
          <div className="row justify-content-center clearfix" style={{backgroundColor:'var(--thm-black)',  marginTop: '30px', padding: '25px 5px'}}>
              <div className="col-12 text-center" style={{padding:"20px"}}>
                  <h2 style={{ fontSize: "30px", margin: "0 0 10px 0", color: 'yellowgreen' }}>Swing. Replay. Improve. Repeat.</h2>
                  <div style={{color:'white', fontSize:'20px', fontWeight:"normal", lineHeight:'2rem'}}>Instant feedback after every shot</div>
                  <div style={{color:'white', fontSize:'20px', fontWeight:"normal"}}>So you can improve faster</div>
              </div>
          </div>





        <div id="get-started" className="atf-section-padding atf-footer-offset">
            <div className="atf-brand-overlay">
                <div className="container">
                    <div className="row justify-content-center clearfix wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s" data-wow-offset="0">
                        <div className="col-lg-8 col-md-8 col-11 text-center atf-mailchamp-headding atf-mailchamp-subscribe">
                            <h2 className="mb-3 text-center">Try for free today</h2>
                            <div>
                                <a href="#none" onClick={() => iphoneAppDownload(`${sportKey}_video_bottom_cta`)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                <a href="#none" onClick={() => androidAppDownload(`${sportKey}_video_bottom_cta`)} ><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={{ height: '65px' }} /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}
